import { CommonModule, NgIf, ViewportScroller } from '@angular/common';
import { Component, HostListener, Injector, computed, signal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DelfiComponentsLibraryModule } from '@mare-common/ngx-delfi-components';
import { DomService, MareLoaderService } from '@mare-common/ngx-mare-loader';
import { UserService } from '../services/user.service';
import { DialogInnovationData, InnovationModalComponent } from './dashboard-components/innovation-modal/innovation-modal.component';
import { MenuItems } from '../shared/menu-items/menu-items';
import { Observable, Subject, Subscription, catchError, finalize, first, firstValueFrom, map, of, takeUntil, tap, throwError } from 'rxjs';
import { PromoContent, PromoService } from '../services/promo.service';
import { CompanyIdentityComponent } from './dashboard-components/company-identity/company-identity.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CardContainerConfig } from '@mare-common/ngx-dynamic-dashboard';
import { UserCompanyService } from '../services/userCompany.service';
import { ComponentIdentityReportComponent } from './dashboard-components/component-identity-report/component-identity-report.component';
import { DashboardOverviewComponent } from './dashboard-components/dashboard-overview/dashboard-overview.component';
import { CommonConfig } from '../shared/common-config/common-config';
import { TokenService } from '../services/token.service';
import { CompanyDataErrorComponent } from './dashboard-components/company-data-error/company-data-error.component';
import { ReportService } from '../services/report.service';
import { ProductsOverviewComponent } from '../products-overview/products-overview.component';
import { ProductsRelatedComponent } from '../products-related/products-related.component';
import { ReportComponent } from '../report/report.component';
import { DashboardType } from './dashboard-type.enum';
import { JsonDataService } from '../services/json-data.service';
import { DashboardPlaymetricsComponent } from './dashboard-components/dashboard-playmetrics/dashboard-playmetrics.component';
import { PromoPlaymetricsComponent } from '../promo/promo-playmetrics/promo-playmetrics.component';
import { PromoProductComponent } from '../promo/promo-product/promo-product.component';
import { ProductService } from '../services/product.service';
import { Product } from '@mare-common/ngx-delfi-components/lib/products-list/product.interface';

@Component({
	selector: 'app-page-dashboard',
	standalone: true,
	imports: [
		CommonModule,	
		DelfiComponentsLibraryModule,
		InnovationModalComponent,
		CompanyIdentityComponent,
		ComponentIdentityReportComponent,
		DashboardOverviewComponent,
		ProductsOverviewComponent,
		ProductsRelatedComponent,
		MatDialogModule,
		TranslateModule,
		SharedModule,
		NgIf,
		CompanyDataErrorComponent,
		ReportComponent,
		DashboardPlaymetricsComponent,
		PromoPlaymetricsComponent,
		PromoProductComponent
	],
	providers: [
		MareLoaderService,
		DomService
	],
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
	showPromoModal!: boolean;
	showPromoModalOffset: number = 200;
	user:any;
	company: any;
	company$ = signal<any>(null);
	companyPiva: any;
	companyEureso: any;
	companyAteco: any;
	missingFinancials$ = signal<boolean>(false);
	companyAnalizingErrors$ = signal<string[]>([]);
	
	
	layoutABtest!: 'a' | 'b';
	dashboardLayout$ = signal<DashboardType>(DashboardType.dashboard);
	isProduction = environment.production;
	productIdsToPromote$ = signal<number[]>([]);
	showProductToPromote$ = signal<boolean>(false);

	loader: any;
	innovationDialogData!: DialogInnovationData;
	
	// showLoader: boolean = false;
	// inPage!: boolean;
	userId!: string;
	innovationSlug: string | null = null;

	private promoModalSubscription!: Subscription;
	promoData: PromoContent[] = [];

	assetPrefixUrl = environment.assetsPrefixUrl;

	graphicDataRos: any

	cardContainerConfigRos!: CardContainerConfig
	isInit = false;

	private unsubscribe$ = new Subject<void>();
	myReportReady$ = signal<boolean>(false);
	reportProcessing$ = signal<boolean>(false);

	reportSubscription: Subscription = new Subscription();
	
	atecoPlaymetrics: any;
	atecopPlaymetricsSubscription: Subscription = new Subscription();


	constructor(public dialog: MatDialog,
		// private eventInteractionService: EventInteractionService,
		loaderService: MareLoaderService,
		private userService: UserService,
		private userCompanyService: UserCompanyService,
		private menuItems: MenuItems,
		private promoService: PromoService,
		private router: Router,
		private viewportScroller: ViewportScroller,
		private commonConfig: CommonConfig,
		private tokenService: TokenService,
		private injector: Injector,
		private reportService: ReportService,
		private jsonDataService: JsonDataService,
		private productService: ProductService
	) {
		this.loader = loaderService;
	}


	ngOnInit(): void {
		// this.layoutABtest = this.commonConfig.getDashboardLayout() as 'a' | 'b';
		this.isInit = false;
		if(this.tokenService.isInit) {
			this.isInit = true
			this._ngOnInit();
		} else {
			let subscription = this.tokenService.isInit$.subscribe((res) => {
				if(res) {
					this.isInit = true
					let timeout = setTimeout(() => {
						clearTimeout(timeout);
						this._ngOnInit();
					}, 200);
					subscription.unsubscribe();
				}
			})
		}

		// const permissions: any = ['geolocation',  'camera', 'window-management', 'notifications'];
		// permissions.forEach((permission: any) => {
		// 	this.checkPermission(permission);
		// })
		
	}

	checkPermission (permission: PermissionName) {
		navigator.permissions.query({ name: permission }).then((result) => {
			console.log(permission, result);
		  });
	}
	_ngOnInit() {
		this.showPromoModal = false
		this.initUserData();
	}

	initUserData() {
		this.userService.getUser().then((user) => {
			if (user) {
				console.log('user_________________', user)
				this.userId = "" + user.userId;
				this.user = user;
			}
			this.userCompanyService.userCompany$.pipe(
				catchError((err: any) => {
					console.log('err', err);
					return of({ company: null });
				}),
				takeUntil(this.unsubscribe$)
				).subscribe((res: any) => {
					this.company = res.company;
					// this.manageCompanyData(this.company);
					this.initDashboard(this.company, this.user).catch((err) => {return err}).then(() => {
						this.manageCompanyData(this.company);
					});	
				console.log('company', this.company)
				}
				);
		});
	}

	initDashboard(company: any, user: any): Promise<any> {
		return new Promise((resolve, reject) => {

			if(user && user['referer-page'] && user['referer-page'].indexOf('playmetrics') > -1) {
				this.setPlaymetrics();
			}

			if (company) {
				let ateco = company.eureso_overview.companySummary?.mainActivity?.code;
				this.checkAtecoForPlaymetrics(ateco).pipe(
					takeUntil(this.unsubscribe$)
				).subscribe((res) => {
					if (res) {
						this.setPlaymetrics();
					} else {
					this.dashboardLayout$.set(DashboardType.dashboard);
					}
				});
				resolve(true);
			} else {
				reject(false);
			}
		})
		
	}

	setPlaymetrics() {
		this.productService.getProductBySku('playmetrics').then((res: any) => {
			let productPlaymetrics = res;

			if (productPlaymetrics.is_purchased || true) {
				let related = productPlaymetrics.products_related;
				// related = related.join(',');
				if (related) {
					this.productIdsToPromote$.set(related);
					this.showProductToPromote$.set(true);
				}
				// console.log(related);
				// this.productService.getProductById(related).then((res_related: any) => {
				// 	console.log(res_related)
					
				// })
				// convert related array to string and join result as a comma separated string
				
				
			}
		}).finally(() => {
			
			this.dashboardLayout$.set(DashboardType.playmetrics);
		});
	}

	checkAtecoForPlaymetrics(ateco: string): Observable<boolean> {
		
		return this.jsonDataService.getJsonData('ateco_playmetrics.json').pipe(
			catchError(err => {
				console.log(err);
				return throwError(() => 'Errore nella lettura delle configurazione');
			}),
			map(data => {
				const found = Object.keys(data).find(el => el.replaceAll('.', '').indexOf(ateco.replaceAll('.', '')) > -1);
				return found ? true : false;
			})
		);
	}

	manageCompanyData(company:any) {

		if (company) {
			if(company?.delfi_report_max_requests && Number(company?.delfi_report_max_requests) > 0) {
				this.reportProcessing$.set(true);
			} else {
				this.reportProcessing$.set(false);
			}
		}
		// this.company$.set(this.company);
		if (company?.eureso_overview) {
			this.companyEureso = company.eureso_overview;
			// this.companyPiva = this.company.alternateSummary?.companyRegistrationNumber
			this.companyPiva = company.eureso_overview.alternateSummary?.vatRegistrationNumber
			this.companyAteco= company.eureso_overview.companySummary?.mainActivity?.code
		} else {
			this.missingFinancials$.set(true);
			this.companyAnalizingErrors$.set(['Dati finanziari mancanti']);
			this.unsubscribe$.next();
			this.unsubscribe$.complete();
		}
		
	}

	promoModalMnagement(){
		this.promoModalSubscription = this.menuItems.getPromosInMenuSubject().subscribe((data) => {
					this.promoData = [];
					this.promoData = data.map(element => {
						let promo = {
							promo_title: element.promo_title,
							promo_text: element.promo_text,
							destination_state: element.menu_state,
						}
						return promo;
					});
					// console.log(this.promoData);
			this.promoService.openPromoModal(this.promoData);
		});
	}

	scrollToElement(elementId: string): void { 
		this.viewportScroller.scrollToAnchor(elementId);
	}

	managePromoModal() {
		this.promoModalSubscription = this.menuItems.getPromosInMenuSubject().subscribe((data) => {
			// console.log('promoModalSubject', data);
			this.promoData = [];

			this.promoData = data.map(element => {
				let promo = {
					promo_title: element.promo_title,
					promo_text: element.promo_text,
					destination_state: element.menu_state,
				}
				return promo;
			});
			// console.log(this.promoData);
			this.promoService.openPromoModal(this.promoData);
		});
	}

	// selectedInnovation(event: any) {
	// 	console.log('selectedInnovation', event);
	// 	this.loaderService.showLoader();
	// 	this._selectedInnovation(event.slug, event);
	// 	this.loaderService.hideLoader();
	// }

	// _selectedInnovation(innovationSlug: string, innovation?: any) {

	// 	this.dialog.open(InnovationModalComponent, {
	// 		width: '100vw',
	// 		height: '100vh',
	// 		maxWidth: '100vw',
	// 		panelClass: 'innovation-subscription',
	// 		data: {
	// 			innovation: innovation,
	// 			innovationSlug: innovationSlug
	// 		}
	// 	});
	// 	this.dialog.afterOpened.subscribe(() => {
	// 		this.loaderService.hideLoader();
	// 	});
	// }



	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		// this.inPage = false;
		this.promoModalSubscription?.unsubscribe();
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}
	toggleLayout() {
		if (this.layoutABtest === 'a') {
			this.layoutABtest = 'b';
		} else {
			this.layoutABtest = 'a';
		}
		this.commonConfig.setDashboardLayout(this.layoutABtest);
	}
}
